import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SteamBathIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SteamBathIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.0901 11.1475C21.9797 11.0061 21.8103 10.9234 21.6309 10.9234H7.60908C7.42974 10.9234 7.26027 11.0061 7.14981 11.1475C7.03951 11.2889 7.00036 11.4732 7.04391 11.6474L8.31946 16.7496H4.65714V10.8234C4.65714 9.6052 4.1827 8.45984 3.32121 7.59835C3.09378 7.37076 2.72478 7.37076 2.49735 7.59835C2.26976 7.82578 2.26976 8.19478 2.49735 8.42221C3.13869 9.06355 3.4919 9.91639 3.4919 10.8234V18.4975C3.4919 19.2758 3.80354 20.009 4.36932 20.562C4.92903 21.1093 5.66581 21.4106 6.44385 21.4106C7.59984 21.4106 8.60061 20.7337 9.07096 19.7556L9.37441 20.9694C9.4392 21.2287 9.67225 21.4106 9.93958 21.4106H19.3004C19.5677 21.4106 19.8008 21.2287 19.8655 20.9694L22.1755 11.7293L22.1962 11.6473C22.2396 11.4732 22.2004 11.2889 22.0901 11.1475ZM8.19171 18.4975C8.19171 19.4612 7.4076 20.2454 6.44384 20.2454C5.47538 20.2454 4.65713 19.445 4.65713 18.4975V17.9149H8.1917L8.19171 18.4975ZM20.8847 12.0886L20.5934 13.2539H8.64658L8.35527 12.0886H20.8847ZM19.4281 17.9149H17.8824L18.3193 14.4191H20.3021L19.4281 17.9149ZM15.1832 17.9149V14.4191H17.145L16.708 17.9149H15.1832ZM12.4931 17.9149L12.0561 14.4191H14.0179V17.9149H12.4931ZM8.93789 14.4191H10.8818L11.3188 17.9149H9.81182L8.93789 14.4191ZM10.3944 20.2454L10.1031 19.0801H19.1368L18.8455 20.2454H10.3944Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3934 8.53647C11.4928 8.60277 11.6049 8.63448 11.7161 8.63448C11.9043 8.63448 12.0891 8.54329 12.2013 8.37488C12.3799 8.10724 12.3075 7.74553 12.0397 7.56695C11.8084 7.41265 11.6756 7.16473 11.6756 6.88647C11.6756 6.60836 11.8084 6.36029 12.0397 6.20599C12.5926 5.83745 12.9228 5.21326 12.9228 4.53657C12.9228 3.85988 12.5926 3.23584 12.0397 2.86715C11.7719 2.68872 11.4102 2.76109 11.2318 3.02874C11.0532 3.29653 11.1256 3.65824 11.3934 3.83667C11.6248 3.99097 11.7575 4.24617 11.7575 4.53657C11.7575 4.82712 11.6248 5.08217 11.3934 5.23647C10.8405 5.60516 10.5104 6.22192 10.5104 6.88647C10.5104 7.55102 10.8405 8.16793 11.3934 8.53647Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.3065 8.53647C14.4059 8.60277 14.518 8.63448 14.6292 8.63448C14.8174 8.63448 15.0022 8.54329 15.1144 8.37488C15.293 8.10724 15.2206 7.74553 14.9528 7.56695C14.7215 7.41265 14.5887 7.16473 14.5887 6.88647C14.5887 6.60836 14.7215 6.36029 14.9528 6.20599C15.5057 5.83745 15.8359 5.21326 15.8359 4.53657C15.8359 3.85988 15.5057 3.23584 14.9528 2.86715C14.6851 2.68872 14.3233 2.76109 14.1449 3.02874C13.9663 3.29653 14.0387 3.65824 14.3065 3.83667C14.5379 3.99097 14.6706 4.24617 14.6706 4.53657C14.6706 4.82712 14.5379 5.08217 14.3065 5.23647C13.7536 5.60516 13.4235 6.22192 13.4235 6.88647C13.4235 7.55102 13.7536 8.16793 14.3065 8.53647Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2196 8.53647C17.319 8.60277 17.4311 8.63448 17.5423 8.63448C17.7305 8.63448 17.9153 8.54329 18.0275 8.37488C18.2061 8.10724 18.1338 7.74553 17.866 7.56695C17.6346 7.41265 17.5018 7.16473 17.5018 6.88647C17.5018 6.60836 17.6346 6.36029 17.866 6.20599C18.4188 5.83745 18.749 5.21326 18.749 4.53657C18.749 3.85988 18.4188 3.23584 17.866 2.86715C17.5982 2.68872 17.2365 2.76109 17.058 3.02874C16.8794 3.29653 16.9518 3.65824 17.2196 3.83667C17.451 3.99097 17.5838 4.24617 17.5838 4.53657C17.5838 4.82712 17.451 5.08217 17.2196 5.23647C16.6667 5.60516 16.3366 6.22192 16.3366 6.88647C16.3366 7.55102 16.6667 8.16793 17.2196 8.53647Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SteamBathIcon;
